import { render, staticRenderFns } from "./HistoryFeedbackScreen.vue?vue&type=template&id=ff24582c&scoped=true"
import script from "./HistoryFeedbackScreen.vue?vue&type=script&lang=js"
export * from "./HistoryFeedbackScreen.vue?vue&type=script&lang=js"
import style0 from "./HistoryFeedbackScreen.vue?vue&type=style&index=0&id=ff24582c&prod&scoped=true&lang=css"
import style1 from "./HistoryFeedbackScreen.vue?vue&type=style&index=1&id=ff24582c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff24582c",
  null
  
)

export default component.exports